"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportError = exports.debug = void 0;
var debug = function debug() {
  return window.location && window.location.hostname === 'localhost';
};
exports.debug = debug;
var reportError = function reportError(e) {
  if (debug()) {
    // eslint-disable-next-line
    console.log(e);
  }
};
exports.reportError = reportError;